import API from '@/models/API';

export default class History {
  static getMonthlyPoints = (query) =>
    API.get(`/stores/${localStorage.getItem('storeId')}/history/monthly-points${query}`);

  static getPointAnalysis = (query) =>
    API.get(`/stores/${localStorage.getItem('storeId')}/history/points${query}`);
}
